import { render, staticRenderFns } from "./ModifyPassword.vue?vue&type=template&id=d4c1333c&scoped=true&"
import script from "./ModifyPassword.vue?vue&type=script&lang=ts&"
export * from "./ModifyPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c1333c",
  null
  
)

export default component.exports